function favTogglePlay(e) {
  e.classList.contains("active")
    ? (e.classList.remove("active"), e.pause())
    : (e.classList.add("active"), e.play());
}
var oldScrollY = window.scrollY;
let isScrolling = false;
function scrollingClass() {
  if (isScrolling) return;
  isScrolling = true;

  window.requestAnimationFrame(() => {
    var t = window.pageYOffset || document.documentElement.scrollTop;
    var body = document.body;

    if (0 === t) {
      body.classList.remove("scrolling", "scrolling-up", "scrolling-down");
      if (body.dataset.invertedHeader === "initially") {
        body.classList.add("inverted-header");
      }
    } else {
      body.classList.add("scrolling");
      if (body.dataset.invertedHeader === "initially") {
        body.classList.remove("inverted-header");
      }
    }

    if (oldScrollY < t) {
      body.classList.add("scrolling-down");
      body.classList.remove("scrolling-up");
    } else {
      body.classList.add("scrolling-up");
      body.classList.remove("scrolling-down");
    }

    oldScrollY = t;

    const header = document.querySelector("header.header");
    if (header) {
      document.documentElement.style.setProperty(
        "--header-scroll-offset",
        parseInt(header.getBoundingClientRect().top) + "px"
      );
    }

    isScrolling = false;
  });
}
if (
  (window.addEventListener("scroll", scrollingClass, { passive: true }),
    scrollingClass(),
    "first-section" == document.body.dataset.invertedHeader)
) {
  let e = document.querySelector(
    "#MainContent > .shopify-section:first-of-type",
  ),
    t = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          (console.log(e.intersectionRatio),
            0 < e.intersectionRatio
              ? document.body.classList.add("inverted-header")
              : document.body.classList.remove("inverted-header"));
        });
      },
      { threshold: 0 },
    );
  e && t.observe(e);
}
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  (e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
    e.nextElementSibling.getAttribute("id") &&
    e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open"),
      );
    }),
    e.closest("header-drawer, menu-drawer") ||
    e.parentElement.addEventListener("keyup", onKeyUpEscape));
});
let trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      "TAB" === e.code.toUpperCase() &&
        (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()),
          e.target === t || e.target === s) &&
        e.shiftKey &&
        (e.preventDefault(), n.focus());
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e.focus(),
    "INPUT" === e.tagName &&
    ["search", "text", "email", "url"].includes(e.type) &&
    e.value &&
    e.setSelectionRange(0, e.value.length));
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  let t = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ],
    e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || (e = document.activeElement).classList.add("focused"));
      },
      !0,
    ));
}
function pauseAllMedia() {
  (document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    }));
}
function removeTrapFocus(e = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus());
}
function onKeyUpEscape(e) {
  var t;
  "ESCAPE" === e.code.toUpperCase() &&
    (e = e.target.closest("details[open]")) &&
    ((t = e.querySelector("summary")),
      e.removeAttribute("open"),
      t.setAttribute("aria-expanded", !1),
      t.focus());
}
class HTMLUpdateUtility {
  static viewTransition(e, t, i = [], s = []) {
    i?.forEach((e) => e(t));
    i = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(i, t.outerHTML);
    let n = i.firstChild,
      o = Date.now();
    (e.querySelectorAll("[id], [form]").forEach((e) => {
      (e.id && (e.id = e.id + "-" + o),
        e.form && e.setAttribute("form", e.form.getAttribute("id") + "-" + o));
    }),
      e.parentNode.insertBefore(n, e),
      (e.style.display = "none"),
      s?.forEach((e) => e(n)),
      setTimeout(() => e.remove(), 500));
  }
  static setInnerHTML(e, t) {
    ((e.innerHTML = t),
      e.querySelectorAll("script").forEach((e) => {
        let t = document.createElement("script");
        (Array.from(e.attributes).forEach((e) => {
          t.setAttribute(e.name, e.value);
        }),
          t.appendChild(document.createTextNode(e.innerHTML)),
          e.parentNode.replaceChild(t, e));
      }));
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    ("plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    var e,
      t = parseInt(this.input.value);
    (this.input.min &&
      ((e = parseInt(this.input.min)),
        this.querySelector(".quantity__button[name='minus']").classList.toggle(
          "disabled",
          t <= e,
        )),
      this.input.max &&
      ((e = parseInt(this.input.max)),
        this.querySelector(".quantity__button[name='plus']").classList.toggle(
          "disabled",
          e <= t,
        )));
  }
}
function debounce(t, i) {
  let s;
  return (...e) => {
    (clearTimeout(s), (s = setTimeout(() => t.apply(this, e), i)));
  };
}
function throttle(i, s) {
  let n = 0;
  return function (...e) {
    var t = new Date().getTime();
    if (!(t - n < s)) return ((n = t), i(...e));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/" + e },
  };
}
(customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i);
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i,
      s = (t = t || {}).method || "post",
      n = t.parameters || {},
      o = document.createElement("form");
    for (i in (o.setAttribute("method", s), o.setAttribute("action", e), n)) {
      var r = document.createElement("input");
      (r.setAttribute("type", "hidden"),
        r.setAttribute("name", i),
        r.setAttribute("value", n[i]),
        o.appendChild(r));
    }
    (document.body.appendChild(o), o.submit(), document.body.removeChild(o));
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    ((this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
      ),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        0 < this.provinceEl.options.length &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (s =
        this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s, n = 0; n < i.length; n++)
          (((s = document.createElement("option")).value = i[n][0]),
            (s.innerHTML = i[n][1]),
            this.provinceEl.appendChild(s));
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        ((s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s));
      }
    },
  }));
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll(
        "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
      ).forEach((e) =>
        e.addEventListener("click", this.onCloseButtonClick.bind(this)),
      ),
      this.querySelectorAll(".close, .button-close").forEach((e) =>
        e.addEventListener("click", (e) => {
          (console.log("gg"), this.closeMenuDrawer());
        }),
      ),
      this.querySelectorAll(".modal__content, .mobile-facets").forEach((e) =>
        e.addEventListener("click", this.shouldClose.bind(this)),
      ));
  }
  shouldClose(e) {
    (e.target.classList.contains("mobile-facets") ||
      e.target.classList.contains("modal__content")) &&
      this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary"));
  }
  onKeyUp(e) {
    var t;
    "ESCAPE" === e.code.toUpperCase() &&
      (t = e.target.closest("details[open]")) &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(
          e,
          this.mainDetailsToggle.querySelector("summary"),
        )
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    let t = e.currentTarget,
      i = t.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      (i.querySelector("button")
        ? trapFocus(t.nextElementSibling, i.querySelector("button"))
        : trapFocus(t.nextElementSibling),
        t.nextElementSibling.removeEventListener("transitionend", r));
    }
    i === this.mainDetailsToggle
      ? (n && e.preventDefault(),
        n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t),
        window.matchMedia("(max-width: 990px)") &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          window.innerHeight + "px",
        ))
      : setTimeout(() => {
        (n
          ? i.classList.remove("menu-opening")
          : i.classList.add("menu-opening"),
          t.setAttribute("aria-expanded", !n),
          s && s.classList.add("submenu-open"),
          !o || o.matches
            ? r()
            : t.nextElementSibling.addEventListener("transitionend", r));
      }, 100);
  }
  openMenuDrawer(e) {
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e));
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
        removeTrapFocus(t),
        this.closeAnimation(this.mainDetailsToggle),
        e instanceof KeyboardEvent) &&
      t?.setAttribute("aria-expanded", !1);
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    e = e.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(e) {
    var t = e.closest(".submenu-open");
    (t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e));
  }
  closeAnimation(t) {
    let i,
      s = (e) => {
        e - (i = void 0 === i ? e : i) < 400
          ? window.requestAnimationFrame(s)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
            trapFocus(
              t.closest("details[open]"),
              t.querySelector("summary"),
            ));
      };
    window.requestAnimationFrame(s);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    ((this.header = this.header || document.querySelector(".section-header")),
      this.header.classList.add("menu-open"),
      document.querySelector("body").classList.add("drawer-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      (this.summary = e).setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, e));
  }
  closeMenuDrawer(e, t) {
    (this.header.classList.remove("menu-open"),
      document.querySelector("body").classList.remove("drawer-open"),
      window.removeEventListener("resize", this.onResize),
      (t = t || this.summary),
      super.closeMenuDrawer(!0, t));
  }
  onResize = () => {
    (FmainDetailsToggle,
      document.documentElement.style.setProperty(
        "--viewport-height",
        window.innerHeight + "px",
      ));
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1),
      ),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
          "mouse" !== e.pointerType ||
            e.target.closest("deferred-media, product-model") ||
            this.hide();
        })
        : this.addEventListener("click", (e) => {
          e.target === this && this.hide();
        }));
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    e = this.querySelector(".template-popup");
    (this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector("button");
    t &&
      t.addEventListener("click", () => {
        var e = document.querySelector(this.getAttribute("data-modal"));
        e && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    var t;
    (window.pauseAllMedia(),
      this.getAttribute("loaded") ||
      ((t = document.createElement("div")).appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          !0,
        ),
      ),
        this.setAttribute("loaded", !0),
        (t = this.appendChild(t.querySelector("video, model-viewer, iframe"))),
        e && t.focus(),
        "VIDEO" == t.nodeName && t.getAttribute("autoplay") && t.play()));
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      this.slider &&
      this.nextButton &&
      (this.initPages(),
        new ResizeObserver((e) => this.initPages()).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        ),
        this.nextButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        )));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (e) => 0 < e.clientWidth,
    )),
      this.sliderItemsToShow.length < 2 ||
      ((this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    var e;
    this.slider &&
      this.nextButton &&
      ((e = this.currentPage),
        (this.currentPage =
          Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
        this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
          (this.pageTotalElement.textContent = this.totalPages)),
        this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
        this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
          0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
          this.isSlideVisible(
            this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
          )
            ? this.nextButton.setAttribute("disabled", "disabled")
            : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(e, t = 0) {
    t = this.slider.clientWidth + this.slider.scrollLeft - t;
    return (
      e.offsetLeft + e.clientWidth <= t &&
      e.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = e.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderItemOffset
        : this.slider.scrollLeft - t * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  setSlidePosition(e) {
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
      ((this.sliderFirstItemNode =
        this.slider.querySelector(".slideshow__slide")),
        0 < this.sliderItemsToShow.length && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(
          ".announcement-bar-slider",
        )),
        (this.announcerBarAnimationDelay = this.announcementBarSlider
          ? 250
          : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((e) =>
          e.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this),
        ),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
        ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          )),
          this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") &&
              this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((e) => {
            e.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              { once: !0 },
            );
          })),
        "true" === this.slider.getAttribute("data-autoplay")) &&
      this.setAutoPlay());
  }
  setAutoPlay() {
    ((this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(
          ".slideshow__autoplay",
        )),
          this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this),
          ),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches ||
          this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play());
  }
  onButtonClick(e) {
    (super.onButtonClick(e), (this.wasClicked = !0));
    var t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    ((t || i) &&
      (t && "previous" === e.currentTarget.name
        ? (this.slideScrollPosition =
          this.slider.scrollLeft +
          this.sliderFirstItemNode.clientWidth *
          this.sliderItemsToShow.length)
        : i &&
        "next" === e.currentTarget.name &&
        (this.slideScrollPosition = 0),
        this.setSlidePosition(this.slideScrollPosition)),
      this.applyAnimationToAnnouncementBar(e.currentTarget.name));
  }
  setSlidePosition(e) {
    (this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({ left: e });
      }, this.announcerBarAnimationDelay)));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link",
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
      (this.sliderControlButtons.forEach((e) => {
        (e.classList.remove("slider-counter__link--active"),
          e.removeAttribute("aria-current"));
      }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active",
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0,
        )));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(e) {
    this.sliderAutoplayButton
      ? ((e =
        e.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(e.target)),
        this.autoplayButtonIsSetToPlay && !e && this.play())
      : this.reducedMotion.matches ||
      this.announcementBarArrowButtonWasClicked ||
      this.play();
  }
  focusInHandling(e) {
    this.sliderAutoplayButton
      ? (e.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(e.target)) &&
        this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause()
      : this.announcementBarSlider.contains(e.target) && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed,
      )));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay));
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove(
        "slideshow__autoplay--paused",
      ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    var e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    (this.setSlidePosition(e), this.applyAnimationToAnnouncementBar());
  }
  setSlideVisibility(e) {
    (this.sliderItemsToShow.forEach((e, t) => {
      var i = e.querySelectorAll("a");
      t === this.currentPage - 1
        ? (i.length &&
          i.forEach((e) => {
            e.removeAttribute("tabindex");
          }),
          e.setAttribute("aria-hidden", "false"),
          e.removeAttribute("tabindex"))
        : (i.length &&
          i.forEach((e) => {
            e.setAttribute("tabindex", "-1");
          }),
          e.setAttribute("aria-hidden", "true"),
          e.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1));
  }
  applyAnimationToAnnouncementBar(o = "next") {
    if (this.announcementBarSlider) {
      var r = this.sliderItems.length,
        a = this.currentPage - 1,
        l = (a + ("next" === o ? 1 : -1)) % r;
      let e = this.sliderItems[-1 == l ? r - 1 : l],
        t = this.sliderItems[a],
        i = "announcement-bar-slider--fade-in",
        s = "announcement-bar-slider--fade-out",
        n =
          ("next" === o && !(a == r - 1)) || ("previous" === o && 0 == a)
            ? "next"
            : "previous";
      (t.classList.add(s + "-" + n),
        e.classList.add(i + "-" + n),
        setTimeout(() => {
          (t.classList.remove(s + "-" + n), e.classList.remove(i + "-" + n));
        }, 2 * this.announcerBarAnimationDelay));
    }
  }
  linkToSlide(e) {
    e.preventDefault();
    e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(e.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("change", (e) => {
      var t = this.getInputForEventTarget(e.target);
      (this.updateSelectionMetadata(e),
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event: e,
            target: t,
            selectedOptionValues: this.selectedOptionValues,
          },
        }));
    });
  }
  updateSelectionMetadata({ target: e }) {
    var t,
      i,
      { value: s, tagName: n } = e;
    "SELECT" === n && e.selectedOptions.length
      ? (Array.from(e.options)
        .find((e) => e.getAttribute("selected"))
        .removeAttribute("selected"),
        e.selectedOptions[0].setAttribute("selected", "selected"),
        (i = e.selectedOptions[0].dataset.optionSwatchValue),
        (t = e
          .closest(".product-form__input")
          .querySelector("[data-selected-value] > .swatch")) &&
        (i
          ? (t.style.setProperty("--swatch--background", i),
            t.classList.remove("swatch--unavailable"))
          : (t.style.setProperty("--swatch--background", "unset"),
            t.classList.add("swatch--unavailable")),
          t.style.setProperty(
            "--swatch-focal-point",
            e.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
          )))
      : "INPUT" === n &&
      "radio" === e.type &&
      (i = e
        .closest(".product-form__input")
        .querySelector("[data-selected-value]")) &&
      (i.innerHTML = s);
  }
  getInputForEventTarget(e) {
    return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
  }
  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset: e }) => e.optionValueId);
  }
}
customElements.define("variant-selects", VariantSelects);
class FavMarquee extends HTMLElement {
  constructor() {
    (super(),
      (this.items = this.querySelectorAll(".item")),
      (this.wrapper = this.querySelector(".wrapper")),
      0 != this.items.length &&
      document.addEventListener(
        "DOMContentLoaded",
        this.initialize.bind(this),
      ));
  }
  initialize() {
    this.width = Array.from(this.items).reduce((acc, item) => acc + item.offsetWidth, 0);
    var t = this.dataset.itemMultiplicator;
    for (let e = 0; e < t; e++)
      this.items.forEach((e) => {
        e = e.cloneNode(!0);
        this.wrapper.appendChild(e);
      });
    (this.wrapper.style.setProperty(
      "--animation-width",
      "-" + this.width + "px",
    ),
      (this.factor = this.width / 300),
      (this.speed = this.dataset.speed * this.factor),
      (this.wrapper.style.animationDuration = this.speed + "s"),
      this.classList.add("active"));
  }
  toggleResetButton() {
    var e = this.resetButton.classList.contains("hidden");
    0 < this.input.value.length && e
      ? this.resetButton.classList.remove("hidden")
      : 0 !== this.input.value.length ||
      e ||
      this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(e) {
    (e.preventDefault(),
      this.shouldResetForm() &&
      ((this.input.value = ""),
        this.input.focus(),
        this.toggleResetButton()));
  }
}
customElements.define("fav-marquee", FavMarquee);
class ContentItem extends HTMLElement {
  constructor() {
    (super(),
      "true" == this.dataset.inverted &&
      window.innerWidth < 769 &&
      (this.style.order =
        "-" +
        Array.prototype.indexOf.call(this.parentElement.children, this)));
  }
}
customElements.define("content-item", ContentItem);
function getShopifySrcset(imageUrl) {
  if (!imageUrl || !imageUrl.includes('cdn.shopify.com')) return imageUrl || '';
  const widths = [375, 430, 500, 680, 750, 900, 1100, 1500, 2200];
  const baseUrl = imageUrl.split('?')[0];
  const params = imageUrl.split('?')[1] || '';
  const cleanParams = params.split('&').filter(p => !p.startsWith('width=') && !p.startsWith('height=') && !p.startsWith('crop=')).join('&');
  const prefix = cleanParams ? `${cleanParams}&` : '';
  return widths.map(w => `${baseUrl}?${prefix}width=${w} ${w}w`).join(', ');
}
class DuskTabs extends HTMLElement {
  constructor() {
    (super(),
      (this.tabs = this.querySelectorAll(":scope > .tab")),
      this.tabs?.forEach((e, t) => {
        (e.style.setProperty("--tab-index", t),
          e.addEventListener("click", this.onClick.bind(this)));
      }),
      (this.contents = this.querySelectorAll(":scope > .content")),
      this.contents?.forEach((e, t) => {
        e.style.setProperty("--content-index", t);
      }),
      this.initialize(),
      window.addEventListener("resize", this.initialize.bind(this)));
  }
  initialize() {
    var e =
      window.innerWidth < 769
        ? this.dataset.typeMobile
        : this.dataset.typeDesktop;
    if ((this.setAttribute("type", e), "tabs" == e)) {
      let i = !1;
      (this.tabs.forEach((e, t) => {
        0 == i && e.classList.contains("active")
          ? (i = !0)
          : i &&
          e.classList.contains("active") &&
          (e.classList.remove("active"),
            this.contents[t].classList.remove("active"));
      }),
        !1 === i &&
        (this.tabs[0]?.classList.add("active"),
          this.contents[0]?.classList.add("active")));
    }
  }
  onClick(e) {
    let i = e.target;
    ((e = i.style.getPropertyValue("--tab-index")), (e = this.contents[e]));
    "accordion" == this.getAttribute("type")
      ? i.classList.contains("active")
        ? (i.classList.remove("active"), e.classList.remove("active"))
        : (i.classList.add("active"), e.classList.add("active"))
      : "tabs" != this.getAttribute("type") ||
      i.classList.contains("active") ||
      (i.classList.add("active"),
        e.classList.add("active"),
        this.tabs.forEach((e) => {
          var t;
          e != i &&
            ((t = e.style.getPropertyValue("--tab-index")),
              (t = this.contents[t]),
              e.classList.remove("active"),
              t.classList.remove("active"));
        }));
  }
}
customElements.define("dusk-tabs", DuskTabs);
class CardProduct extends HTMLElement {
  constructor() {
    (super(),
      (this.links = this.querySelectorAll("a")),
      (this.swatches = this.querySelectorAll("dusk-swatch")),
      (this.idInput = this.querySelector('input[name="id"]')),
      (this.duskPicture = this.querySelector("dusk-picture.primary")),
      (this.duskPictureSecondary = this.querySelector(
        "dusk-picture.secondary",
      )));
  }
  connectedCallback() {
    this.swatches?.forEach((e) => {
      e.addEventListener("click", this.swatchClick.bind(this));
    });
  }
  disconnectedCallback() { }
  swatchClick(e) {
    let t = e.currentTarget;
    if (
      (t.classList.add("active"),
        this.swatches.forEach((e) => {
          e != t && e.classList.remove("active");
        }),
        void 0 !== t.dataset.variantUrl &&
        this.links.forEach((e) => {
          e.setAttribute("href", t.dataset.variantUrl);
        }),
        void 0 !== t.dataset.variantId &&
        this.idInput?.setAttribute("value", t.dataset.variantId),
        void 0 !== t.dataset.image)
    ) {
      let img = this.duskPicture?.querySelector('img');
      if (img) {
        img.setAttribute('srcset', getShopifySrcset(t.dataset.image));
        img.setAttribute('src', t.dataset.image + (t.dataset.image.includes('?') ? '&' : '?') + 'width=1500');
      }
    }
    if (void 0 !== t.dataset.imageHover) {
      let imgSecondary = this.duskPictureSecondary?.querySelector('img');
      if (imgSecondary) {
        imgSecondary.setAttribute('srcset', getShopifySrcset(t.dataset.imageHover));
        imgSecondary.setAttribute('src', t.dataset.imageHover + (t.dataset.imageHover.includes('?') ? '&' : '?') + 'width=1500');
      }
    }

    // Update price
    const priceContainer = this.querySelector('.price');
    if (priceContainer && t.dataset.price) {
      const newPrice = t.dataset.price;
      const newComparePrice = t.dataset.compareAtPrice;

      if (newComparePrice && newComparePrice.length > 0) {
        priceContainer.classList.add('price--on-sale');
        const compareEl = priceContainer.querySelector('.price__sale s.price-item');
        if (compareEl) compareEl.innerHTML = newComparePrice;

        const salePriceEl = priceContainer.querySelector('.price__sale .price-item--sale');
        if (salePriceEl) salePriceEl.innerHTML = newPrice;
      } else {
        priceContainer.classList.remove('price--on-sale');
        const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');
        if (regularEl) regularEl.innerHTML = newPrice;
      }
    }

    // Update button state
    const submitButton = this.querySelector('button[type="submit"]');
    if (submitButton) {
      const isSoldOut = t.getAttribute("disabled") === "true";
      const buttonSpan = submitButton.querySelector("span:not(.sold-out-message):not(.loading__spinner)");

      if (isSoldOut) {
        submitButton.setAttribute("disabled", "disabled");
        if (buttonSpan && submitButton.dataset.soldOutText) {
          let textWrapper = buttonSpan.querySelector('.quick-add__submit-text');
          if (textWrapper) {
            textWrapper.textContent = submitButton.dataset.soldOutText;
          } else {
            buttonSpan.childNodes[0].textContent = submitButton.dataset.soldOutText;
          }
        }
      } else {
        submitButton.removeAttribute("disabled");
        if (buttonSpan && submitButton.dataset.addToCartText) {
          let textWrapper = buttonSpan.querySelector('.quick-add__submit-text');
          if (textWrapper) {
            textWrapper.textContent = submitButton.dataset.addToCartText;
          } else {
            buttonSpan.childNodes[0].textContent = submitButton.dataset.addToCartText;
          }
        }
      }
    }
  }
}
customElements.define("card-product", CardProduct);
